module.exports = __webpack_public_path__ + "static/media/icons_Evaluation télésoin.8337de69.svg";